<div class="accordion">
  <ul class="accordion__menu">
    @for (item of accordionData(); track item._id) {
      @if (item.question && item.answer) {
        <li
          class="accordion-item"
          [ngClass]="{ 'accordion-item--active': activeItem === item._id }">
          <!-- item head -->
          <div
            class="accordion-item__head"
            (click)="openAccordionItem(item._id)">
            <div class="accordion-title">
              <!-- accordion icon -->
              <span class="accordion-title__icon-container">
                <i
                  class="iconsax accordion-title__icon"
                  [ngClass]="{ '!text-gray-600': activeItem === item._id }"
                  [attr.icon-name]="
                    activeItem === item._id ? 'minus' : 'add'
                  "></i>
              </span>

              <!-- question -->
              <h4 class="accordion-title__text">
                @if (isString(item.question)) {
                  <span> {{ item.question.toString() | translate }}</span>
                } @else {
                  <span>{{ item.question | translateData }}</span>
                }
              </h4>
            </div>
            <!-- details -->
            @if (item.details) {
              <p class="accordion-details">
                {{ item.details | translate | translateData }}
              </p>
            }
          </div>
          <!-- item body -->
          <div class="accordion-item__body">
            <div class="accordion-item__body-content">
              @if (isString(item.answer)) {
                <span>{{ item.answer.toString() | translate }}</span>
              } @else {
                <span>{{ item.answer | translateData }}</span>
              }
              @if (item?.url && item.urlTitle) {
                <a [routerLink]="item?.url">
                  ({{ item.urlTitle | translate }})
                </a>
              }
            </div>
          </div>
        </li>
      }
    }
  </ul>
</div>
